import { Pipe, PipeTransform } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { DateLocalePipe } from './dateLocale.pipe';

//REV-21360 — moved here from `aumico-project-reports` (financial-closing-process): a library must
// not import from an app, and the ABCP workspace header needs this pipe too.
// Functionally unchanged — same i18next keys, same calculation.

@Pipe({
    name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
    constructor(private readonly localizedText: I18NextService, private readonly dateLocalePipe: DateLocalePipe) {}
    transform(value: Date | string): string {
        const currentDate = new Date();
        const inputDate = new Date(value);
        const timeDifference = currentDate.getTime() - inputDate.getTime();

        const diffInSeconds = Math.floor(timeDifference / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        // Handle "just now" (less than 1 hour difference)
        if (diffInHours < 1) {
            return this.localizedText.t('aumico_reports_just_now') as string;
        }

        // Handle same day (less than 24 hours difference)
        if (diffInDays < 1) {
            const textKey = diffInHours > 1 ? 'aumico_reports_hours_of_uploading' : 'aumico_reports_hour_of_uploading';
            return this.localizedText.t(textKey, {
                diffInHours,
            }) as string;
        }

        // Handle less than a week (less than 7 days difference)
        if (diffInDays < 7) {
            const textKey = diffInDays > 1 ? 'aumico_reports_days_of_uploading' : 'aumico_reports_day_of_uploading';
            return this.localizedText.t(textKey, {
                diffInDays,
            }) as string;
        }

        return this.dateLocalePipe.transform(inputDate).toString();
    }
}
